import HeaderProfile from './connected';

export default HeaderProfile;